module.exports = __webpack_public_path__ + "img/commandImg2.74b6cf18.png";